export default __webpack_public_path__ + "static/media/img3.e1c0d1e5.png";